import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'auth_token';

@Injectable({ providedIn: 'root' })
export class SessionTokenService {
  private _token = signal<string | null>(typeof localStorage !== 'undefined'
    ? localStorage.getItem(STORAGE_KEY)
    : null);

  get token() { return this._token(); }

  setToken(t: string) {
    this._token.set(t);
    try { localStorage.setItem(STORAGE_KEY, t); } catch {}
  }

  clear() {
    this._token.set(null);
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  }
}
